import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import HomeOriginal from "./pages/Home"; // Backup der Original-Version
import GmbhGruenden from "./pages/GmbhGruenden";
import Komplettpaket from "./pages/Komplettpaket";
import Marktplatz from "./pages/Marktplatz";
import UeberUns from "./pages/UeberUns";
import Kontakt from "./pages/Kontakt";
import Rechtliches from "./pages/Rechtliches";
import OnboardingForm from "./pages/OnboardingForm";
import SellerOnboardingForm from "./pages/SellerOnboardingForm";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminDetail from "./pages/AdminDetail";
import AdminListings from "./pages/AdminListings";
import AdminNewsletter from "./pages/AdminNewsletter";
import NewsletterBestaetigt from "./pages/NewsletterBestaetigt";
import HomeTasteSkill from "./pages/HomeTasteSkill";
import HomeTasteSkillV2 from "./pages/HomeTasteSkillV2";
import HomeTasteSkillV3 from "./pages/HomeTasteSkillV3";
import HomeTasteSkillV3Final from "./pages/HomeTasteSkillV3Final";
import GmbHDetail from "./pages/GmbHDetail";

function App() {
  return (
    <HelmetProvider>
      {/* SEO-Tags werden von den einzelnen Seitenkomponenten via PageSEO gesetzt */}
      <div className="App">
        <BrowserRouter>
          <Header />
        <Routes>
          <Route path="/" element={<HomeTasteSkillV3Final />} />
          <Route path="/home-v3" element={<HomeTasteSkillV3 />} />
          <Route path="/home-v1" element={<HomeTasteSkill />} />
          <Route path="/home-original" element={<HomeOriginal />} />
          <Route path="/gmbh-gruenden" element={<GmbhGruenden />} />
          <Route path="/onboarding" element={<OnboardingForm />} />
          <Route path="/seller-onboarding" element={<SellerOnboardingForm />} />
          <Route path="/komplettpaket" element={<Komplettpaket />} />
          <Route path="/marktplatz" element={<Marktplatz />} />
          <Route path="/gmbh-kaufen/:slug" element={<GmbHDetail />} />
          <Route path="/ueber-uns" element={<UeberUns />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/rechtliches" element={<Rechtliches />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/listings" element={<AdminListings />} />
          <Route path="/admin/newsletter" element={<AdminNewsletter />} />
          <Route path="/admin/:type/:id" element={<AdminDetail />} />
          <Route path="/newsletter-bestaetigt" element={<NewsletterBestaetigt />} />
        </Routes>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
